module.exports = __webpack_public_path__ + "img/logo-lieu.c3244ff2.png";